<template>
  <div class="container sv023">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>ご登録口座へのお振込み</heading-one>

    <p>パソコン・スマートフォンがあれば、簡単なお手続きでご登録いただいた口座へのお振込みが可能です。振込手数料はかかりません。</p>

    <table-box class="_mb-20">
      <table-body>
        <table-row>
          <table-header>お振込み可能時間</table-header>
          <table-data>
            午前4：00～翌午前2：00まで<br>※日中時間帯はご利用いただけます。
          </table-data>
        </table-row>
      </table-body>
    </table-box>

    <P>＜ご注意＞</P>
    <p>下記メンテナンス時間は、お申し込みができません。</p>
    <list-group class="-normal">
      <list-item class="-normal">ご利用いただけない時間帯および特定日</list-item>
    </list-group>
    <list-group class="_mb-md-60 _mb-sm-40">
      <list-item>毎日深夜2:00～4:00</list-item>
      <list-item>毎週日曜日19:00～翌月曜日8:00</list-item>
      <list-item>年始1月1日～3日、ゴールデンウィーク5月3日～5日</list-item>
      <list-item>また、ご利用されている金融機関が営業時間外の場合にはお振込みができません。</list-item>
    </list-group>

    <!--<list-group class="-note _mb-md-60 _mb-sm-40">-->
      <!--<list-item class="-note">年末年始などの特定日や、メンテナンス時間帯はご利用いただけません。他のお借り入れ方法にてご利用ください。</list-item>-->
      <!--<list-item class="-note">ご利用されている金融機関によってお振込み可能な時間が異なります。</list-item>-->
      <!--<list-itemp>＜ご利用いただけない時間帯および特定日＞<br>毎日深夜2:00～4:00<br>毎週日曜日19:00～翌月曜日8:00<br>年始1月1日～3日、ゴールデンウィーク5月3日～5日</list-itemp>-->
    <!--</list-group>-->

    <!--<sv023-header></sv023-header>-->
    <section>
      <step-list type="sv" class="_mb-md-60 _mb-sm-20 -orange">
        <heading-two>口座へのお振込みによるお借り入れ方法</heading-two>
        <step-item number="1" title="会員さま専用サイトへログイン" src="sv/sv023/step1.jpg" src-sp="sv/sv023/sp/step1.jpg">
          <p>会員さま専用サイトへログインします。</p>
          <list-group class="-note">
            <list-item class="-note">au PAY スマートローンアプリでもお手続きが可能です。</list-item>
          </list-group>
          <btn-main class="-normal" routerName="ce001">
            会員さま専用サイトへ
          </btn-main>
        </step-item>
        <step-item number="2" title="「ご登録口座へのお振込み」を選択" src="sv/sv023/step2.jpg" src-sp="sv/sv023/sp/step2.jpg">
          <p>会員さま専用サイトのお借り入れメニュー内より「ご登録口座へのお振込み」を選択ください。</p>
        </step-item>
        <step-item number="3" title="お借り入れ金額をご入力のうえ「お申し込み」を押下" src="sv/sv023/step3.jpg" src-sp="sv/sv023/sp/step3.jpg" class="-last">
          <p>暗証番号認証後、お借り入れ金額をご入力のうえ、確認画面に進み「お申し込み」ボタンを押してください。</p>
          <btn-main class="-normal -md" routerName="ce001">
            口座のご登録・変更はこちらから
          </btn-main>
        </step-item>
        <step-footer>
          <template slot="heading">お手続き完了</template>
        </step-footer>
      </step-list>
    </section>

    <section>
      <heading-two>ご利用可能な金融機関</heading-two>
      <p>お借り入れ・ご返済の際にご利用いただける金融機関を紹介しています。</p>
      <btngroup-single class="-margin-lg">
        <btn-main class="-normal" routerName="sv018">
          ご利用可能な金融機関へ
        </btn-main>
      </btngroup-single>
    </section>

    <cv-box class="_mb-md-120 _mb-sm-60"/>

    <contact-box class="_mb-md-120 _mb-sm-60"/>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import StepList from '../components/steps/StepList'
import StepItem from '../components/steps/StepItem'
import StepFooter from '../components/steps/StepFooter'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import CvBox from '../components/box/CvBox'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import ContactBox from '../components/box/ContactBox'

export default {
  name: 'Sv-023',
  metaInfo: {
    title: 'ご登録口座へのお振込み｜お借り入れ方法',
    meta: [
      {name: 'description', content: 'ご登録の口座へのお振込みによるお借り入れ方法をご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,登録口座'}
    ]
  },
  components: {
    ContactBox,
    CardBody,
    CardHeader,
    CardBox,
    CvBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtngroupSingle,
    BtnMain,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    StepList,
    HeadingOne,
    HeadingTwo
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'お借り入れについて',
        routerName: 'sv046'
      },
      {
        text: 'ご登録口座へのお振込み',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
</style>



// WEBPACK FOOTER //
// src/pages/Sv023.vue